import {IGridStatus} from '../../ap-interface/interfaces/ap-grid-status.interface';
import IGuid = System.IGuid;
import IInstrument = Data.DocuContext.Instrument.IInstrument;

export enum InstrumentsPagerAction {
  Active = 0,
  Inactive = 1,
  Deleted = 2
}

export interface IInstrumentGridData {
  Id: IGuid;
  Status: IGridStatus;
  Name: string;
  DefaultWidth: number;
  DefaultWorkTypeName: string;
  SourceItem: IInstrument;
}
